var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"antialiased"},[_c('Sidebar'),_c('div',{staticClass:"page"},[_c('Header',{attrs:{"hint":_vm.hintKeyword,"enabled":_vm.enabledKeyword},on:{"change":_vm._search}}),_c('div',{staticClass:"content container"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }